// extracted by mini-css-extract-plugin
export var orderSummary = "_p0-0";
export var showMoreLessButton = "_p0-1";